<template lang="pug">
  .color-solutions.xs-f-small.max-at-tweak
    .color-solutions-hero.container
      .row
        .fixed-width-tweak-upper
          .hero-wrap.xs-12
            .hero-text-wrap
              h1.hero-title.bold.xs-f-large.md-f-grande.lg-f-xgrande.max-at-tweak We want you to love your results&mdash;so your next box of color is free, on us.
              p.hero-text.color-slate.xs-f-medium.md-f-xxlarge.lg-f-xxxlarge.max-at-tweak Tips to help you achieve 100% gray coverage.

            .image-wrap
              .a-box-xs-1x1
                .a-box-content
                  img-box(media-id="6348")
                  p.image-label.bold.xs-f-xsmall.md-f-small.max-at-tweak - Rachael, Lead Colorist

            .questions-wrap
              p.color-triple-nines.xs-f-xsmall.md-f-medium.max-at-tweak Want a colorist’s opinion first? <br/>
                button.btn-reset.color-purple.semi-bold(@click="openColoristModal") Please click here.
          
    .better-application.container(v-if="neverBoughtBowlAndBrush")
      .row.text-center
        .fixed-width-tweak-upper
          .solution.xs-12
            .xs-12
              span.number.color-white.xs-f-xmedium.md-f-large.lg-f-xxxlarge.max-at-tweak
              h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak Try a better application
              p.bold.xs-f-medium.md-f-xmedium.max-at-tweak The #1 most common gray coverage&nbsp;issue?
              p.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak Not fully saturating your roots and other resistant areas with color.
              p.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak We recommend using a bowl &amp; brush to thoroughly and evenly apply your color for maximum saturation.
            
            .bowl-and-brush-wrap.xs-12
              .line
              ProductCheckbox(:product="bowlAndBrush" v-model="addBowlAndBrush")
              .line

    .additional-minutes.container(v-if="suggestAdditionalProcessingTime")
      .row.text-center
        .fixed-width-tweak-upper
          .solution.has-line.xs-12
            span.number.color-white.xs-f-xmedium.md-f-large.lg-f-xxxlarge.max-at-tweak
            h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak Add an additional ten minutes to processing time
            p.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak For superior coverage, let your color process for a total of 55&nbsp;minutes
            .bottom-line

    .total-saturation.container
      .row.text-center
        .fixed-width-tweak-upper
          .solution.has-line.xs-12
            span.number.color-white.xs-f-xmedium.md-f-large.lg-f-xxxlarge.max-at-tweak
            h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak Ensure total saturation
            ul.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak
              li.xs-f-medium.md-f-xmedium.max-at-tweak Make sure to fully saturate your roots, hairline, and any resistant areas with color
              li.xs-f-medium.md-f-xmedium.max-at-tweak Take very thin sections and apply your color generously <br/>(imagine frosting a cake)
              li.xs-f-medium.md-f-xmedium.max-at-tweak Use at least half of your color on roots only
            .bottom-line

    .how-to-video.container
      .row.text-center
        .fixed-width-tweak-upper
          .solution.has-line.xs-12
            span.number.color-white.xs-f-xmedium.md-f-large.lg-f-xxxlarge.max-at-tweak
            h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak Watch helpful how-tos
            p.how-to-text.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak Our resident gray coverage expert, colorist Dinna, knows all about getting rid of stubborn grays.
            youtube-player.how-to-video-player(player-id="how-to-video" video-code="O6gJeky0dCc")
            .bottom-line

    .new-recommendation.container
      .row.text-center
        .fixed-width-tweak-upper
          .solution.has-line.xs-12
            .xs-12
              span.number.color-white.xs-f-xmedium.md-f-large.lg-f-xxxlarge.max-at-tweak
              template(v-if="recIsNNN")
                h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak Use a shade that’s tough on grays
                p.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak Your new match is one of our NNN shades, which are specifically formulated for maximum gray coverage.
              template(v-else)
                h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak Use this shade for best results
                p.color-slate.xs-f-medium.md-f-xmedium.max-at-tweak Your new match is a better fit for your gray coverage needs.
            
            .new-rec-wrap.xs-12
              .line
              ProductCheckbox(:product="colorRec" v-model="addColorKitRec" :just-for-show="true")
              .line

            .cta-wrap.xs-12
              button.mr-btn.btn-inverse.btn-fixed-width.xs-f-xsmall.max-at-tweak(type='button' @click="openColoristModal") Get a colorist's opinion
              button.view-order.btn-reset(@click="$root.scrollTo('.on-us')")
                span.color-purple.semi-bold.upper.xs-f-medium.max-at-tweak View Order
                span.icon-caret-down.color-slate.xs-f-large.max-at-tweak
            
            .xs-12
              .bottom-line

    .on-us.container(v-if="addBowlAndBrush || addColorKitRec")
      .row.text-center
        .fixed-width-tweak-upper
          .on-us-wrap.xs-12
            .xs-12
              span.number.color-white.xs-f-xmedium.md-f-large.lg-f-xxxlarge.max-at-tweak
              h3.bold.xs-f-large.md-f-xxlarge.max-at-tweak This one's on us
              
            .products.xs-12
              ProductLineItem(v-if="addColorKitRec" :product="colorRec")
              ProductLineItem(v-if="addBowlAndBrush" :product="bowlAndBrush")

            .cta-wrap.xs-12
              button.mr-btn.btn-fixed-width.xs-f-xsmall.max-at-tweak(type='button' @click="checkout()") Continue to checkout
              p.color-slate.xs-f-medium.max-at-tweak(v-if="orderData && orderData.subscriptionId && !subInEdit.inactive") Your delivery schedule will reset once your new color has shipped.

</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import vueCustomerSvc from '../../services/vueCustomerSvc';
  import vueProductSvc from '../../services/vueProductSvc';

  import ProductCheckbox from "./ProductCheckbox";
  import ProductLineItem from "./ProductLineItem";

  export default {
    name: "ColorSolutions",

    components: {
      ProductCheckbox,
      ProductLineItem
    },

    data() {
      return {
        bowlAndBrushProductId: 122,
        proColorToolKitProductId: 145,
        addBowlAndBrush: false,
        addColorKitRec: true,
        numberOfNumbers: 0
      }
    },

    computed: {
      ...mapState('moreColorOptions', ['selectedColor']),
      ...mapState('subscriptions', ['subInEdit']),
      ...mapState('customer', ['cdata']),

      colorRec() {
        if (this.selectedColor) {
          this.selectedColor.price = 0;
          return this.selectedColor;
        } else {
          return this.adjustedBestMatch;
        }
      },

      recIsNNN() {
        return this.colorRec && !!~this.colorRec.code.indexOf('NNN');
      },

      neverBoughtBowlAndBrush() {
        var neverBought = true;

        if (this.cdata && this.cdata.purchasedProductIds && (this.cdata.purchasedProductIds.indexOf(this.bowlAndBrushProductId) >= 0 || this.cdata.purchasedProductIds.indexOf(this.proColorToolKitProductId) >= 0) ) {
          neverBought = false;
        }

        return neverBought;
      },

      suggestAdditionalProcessingTime() {
        var suggestTime = false;

        if (this.$root.surveyAnswers && this.$root.surveyAnswers.color_satisfaction_survey_v4 && this.$root.surveyAnswers.color_satisfaction_survey_v4.color_process_time_roots != 'more_than_45') {
          suggestTime = true;
        }

        return suggestTime;
      },

      orderId() {
        if (this.$root.surveyAnswers && this.$root.surveyAnswers.color_satisfaction_survey_v4 && this.$root.surveyAnswers.color_satisfaction_survey_v4.order_id) {
          return this.$root.surveyAnswers.color_satisfaction_survey_v4.order_id;
        }
      }
    },

    asyncComputed: {
      bowlAndBrush() {
        return vueProductSvc.getProductById({id: this.bowlAndBrushProductId}).then(res => res.data);
      },

      surveyColor() {
        if (this.$root.surveyAnswers && this.$root.surveyAnswers.color_satisfaction_survey_v4 && this.$root.surveyAnswers.color_satisfaction_survey_v4.product_id) {
          return vueProductSvc.getProductById({ id: this.$root.surveyAnswers.color_satisfaction_survey_v4.product_id }).then(res => res.data);
        }
      },

      orderData() {
        if (this.orderId && this.surveyColor && this.surveyColor.id) {
          return vueCustomerSvc.getOrderDataForColorSolution({
            orderId: this.orderId,
            productId: this.surveyColor.id
          }).then(res => {
            if (res.data.subscriptionId) {
              this.populateSubInEditById(res.data.subscriptionId);
            }
            return res.data;
          });
        }
      },

      adjustedBestMatch() {
        return this.$http.get('/api/advisor/getColorSolution').then(res => {
          res.data.price = 0;
          return res.data;
        });
      }
    },

    methods: {
      ...mapMutations('moreColorOptions', ['setSelectedColor']),
      ...mapActions('cart', ['addToCart']),
      ...mapActions('subscriptions', ['initSubscriptions', 'populateSubInEditById', 'updateSubscriptionColor', 'shipNow']),

      updateNumbers() {
        var numbers = $('.color-solutions .number');
        if (this.numberOfNumbers != numbers.length) {
          this.numberOfNumbers = numbers.length;
          for (var x = 0; x < numbers.length; x++) {
            numbers[x].textContent = x + 1;
          }
        }
      },

      openColoristModal() {
        this.$store.dispatch('modal/showModal', { component: './ColorSolutions/ColorSolutionsColoristOpinionModal' });
      },

      openSeeMoreChoices() {
        if (this.colorRec && this.colorRec.id) {
          this.setSelectedColor(this.colorRec);
          this.$store.dispatch('modal/showModal', { component: './ColorSolutions/ColorSolutionsMoreOptionsModal', theme: 'try-it-on-modal'})
        }
      },

      checkout() {
        vueCustomerSvc.assignCustomerPromo({
          promoId: 2849
        }).then(() => {
          vueCustomerSvc.assignCustomerPromo({
            promoId: 2858
          }).then(() => {
            if (this.orderData.subscriptionId && !this.subInEdit.inactive) {
              // update sub to new color and ship now
              this.updateSubscriptionColor({subscriptionId: this.orderData.subscriptionId, productId: this.colorRec.id}).then(() => {
                if (this.addBowlAndBrush) {
                  this.addToCart({
                    productId: this.bowlAndBrush.id,
                    ctaSource: 'ColorSolutions',
                    cartType: 'refill'
                  }).then(() => {
                    this.shipNow({ subId: this.orderData.subscriptionId });
                  });
                } else {
                  this.shipNow({ subId: this.orderData.subscriptionId });
                }
              });
            } else {
              // add to cart and go to checkout
              var payload = {
                productId: this.colorRec.id,
                ctaSource: 'ColorSolutions',
                cartType: 'active'
              };

              if (this.orderData.extraTube) {
                payload.extra = true;
              }
              
              this.addToCart(payload).then(() => {
                if (this.addBowlAndBrush) {
                  this.addToCart({
                    productId: this.bowlAndBrush.id,
                    ctaSource: 'ColorSolutions',
                    cartType: 'active'
                  }).then(() => {
                    location.href = '/checkout';
                  });
                } else {
                  location.href = '/checkout';
                }
              });
            }
          });
        }).catch(err => {
          if (err && err.response.data && err.response.data.code == 'REST_ACCESS_DENIED') {
            window.location = '/signIn#?next=' + encodeURIComponent(this.$route.path);
          }
        });
      }
    },

    created() {
      this.initSubscriptions();
    },

    mounted() {
      setInterval(() => {
        this.updateNumbers();
      }, 300);
    }
  }
</script>

<style scoped lang="stylus">
  .color-solutions
    padding-bottom 2em
    
    .row
      overflow hidden
      
    .color-solutions-hero
      .hero-wrap
        padding-left 10%
        padding-right 38%
        padding-top 2em
        padding-bottom 3.5em
        
      .hero-text-wrap
        position relative
        z-index 5
        
      .hero-title
        padding-bottom 0.5em
        
      .hero-text
        padding-bottom 1em
        
      .image-wrap
        overflow visible
        position absolute
        top 2em
        right 10%
        width 36%
        z-index 1
        
        .a-box-content
          overflow visible
          
        .image-label
          position absolute
          left 0
          right 0
          bottom -2.5em
          text-align center
    
    .line
    .bottom-line
      width 100%
      height 1px
      background-color color-fog-light
    
    .number
      display inline-block
      background-color color-mr-purple
      border-radius 50%
      width 1.5em
      height 1.5em
      line-height 1.5em
      
    .solution
    .on-us-wrap
      padding 2.5em 5%
      
      h3
      p
      li
        padding-top 1em
        
      &.has-line
        padding-bottom 0
        
        .bottom-line
          margin-top 2.5em
        
    .better-application
      .bowl-and-brush-wrap
        margin-top 1.5em
        
        .product-checkbox
          margin 1em 0

    .total-saturation
      ul
        text-align left
        list-style disc
        margin-left 1.5em
        
    .how-to-video
      .how-to-video-player
        margin 1.5em 0

    .new-recommendation
      .new-rec-wrap
        margin 1.5em 0
        
        .product-checkbox
          margin 1em 0
          
      .cta-wrap
        padding-top 1em
        
        .view-order
          position relative
          display block
          margin 0 auto
          margin-top 1em
          padding 0.5em
          
          .icon-caret-down
            position absolute
            left 50%
            margin-left -0.75em
            bottom -1em
        
      .more-options-cta
        margin-bottom 1.25em

    .on-us
      .on-us-wrap        
        h3
          padding-bottom 0.5em
          
        .cta-wrap
          padding-top 1.5em

    @media mq-mobile
      .number
        border-radius 50%
        width 1.75em
        height 1.75em
        line-height 1.75em
        
      .color-solutions-hero
        .hero-wrap
          padding-left 5%
          padding-right 5%
          padding-bottom 1em
          
          .hero-title
            padding-right 25%
            
          .hero-text
            padding-right 45%
          
        .image-wrap
          right 5%
          
          .a-box-xs-1x1
            width 140%
            
            .image-label
              left -35%
              
        .questions-wrap
          padding-top 1em
          text-align center
      
      .additional-minutes
        h3
        p
          padding-left 3%
          padding-right 3%

    @media mq-tablet
      .solution
      .on-us-wrap
        padding 2.5em 18%
        
      .color-solutions-hero
        .hero-wrap
          padding-left 10%
          padding-right 10%
          
          .hero-title
            padding-right 45%
            
          .hero-text
            padding-right 50%
          
        .image-wrap
          right 10%
              
        .questions-wrap
          padding-top 1em
      
      .additional-minutes
        h3
        p
          padding-left 10%
          padding-right 10%
          
      .how-to-video
        .how-to-text
          padding-left 5%
          padding-right 5%

    @media mq-desktop-md
      .solution
      .on-us-wrap
        padding 2.5em 22%
        
      .color-solutions-hero
        .hero-wrap
          padding-left 5%
          padding-right 35%
          
          .hero-text
            padding-right 30%
          
          .image-wrap
            right 5%
            
      .additional-minutes
        h3
        p
          padding-left 5%
          padding-right 5%
          
      .how-to-video
        .how-to-text
          padding-left 10%
          padding-right 10%
    
    @media mq-desktop-plus
      .solution
      .on-us-wrap
        padding 2.5em 24%
        
      .color-solutions-hero
        .hero-wrap
          .hero-text
            padding-right 15%
            
      .additional-minutes
        h3
        p
          padding-left 10%
          padding-right 10%
          
      .total-saturation
        ul
          margin-left 3.5em
          
      .how-to-video
        .how-to-text
          padding-left 5%
          padding-right 5%
            
</style>
